<div style="text-align: right; cursor: pointer;">
        <i class="material-icons __close-button" (click)="onNoClick()" matTooltip="Close">close</i>
    </div>
<textarea *ngIf="isInspector" #textArea [(ngModel)]="comment" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" [readonly]="isViewMode ?? false"></textarea>
<span *ngIf="!isInspector">{{comment}}</span>
<div style="display: flex;justify-content: space-between;">
    <button *ngIf="isInspector && !(isViewMode ?? false)" mat-raised-button class="button" color="warn" 
    (click)="updateComment(comment)" [class.loading]="savingComment"
     [disabled]="savingComment"><span>{{'Save Comment' | translate | async}}</span></button>


    <div *ngIf="CompartTypeCommentList!=null && CompartTypeCommentList.length>0" style="width: 300px;
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;" >
        <mat-form-field>
            <mat-select id="compartTypeComment" [(ngModel)]="compartTypeComment">
                <mat-option [value]="r.Name" *ngFor="let r of CompartTypeCommentList">{{r.Name}}</mat-option>
            </mat-select>
            <mat-label>{{'Auto Comment' | translate | async}}</mat-label>
        </mat-form-field>

        <button *ngIf="isInspector" mat-raised-button class="button" color="warn"
            (click)="AddCompartTypeComment()"><span>{{'Add' | translate | async}}</span></button>
    </div>


</div>